import React, { useState, useCallback, useEffect } from 'react';
import { SearchMinor } from '@shopify/polaris-icons';
import { gql, useMutation, useQuery, useLazyQuery } from '@apollo/client';
import {
  Autocomplete,
  TextField,
  Icon,
  TextContainer,
  Spinner,
} from '@shopify/polaris';

const SearchVariants = (props) => {
  const { i18n } = props;
  const { value, setFieldValue, fieldName, allVariants, error, setAllVarients } = props;
  // Search variant to add
  const GET_VARIANTS = gql`
  query ($query: String!) {
    productVariants(first: 10, query: $query) {
        edges {
            node {
                    id
                    title
                    price
                    inventoryQuantity
                    selectedOptions {
                      name
                      value
                    }
                    product {
                        id
                        title
                        images(first: 1) {
                            edges {
                                node {
                                    originalSrc
                                }
                            }
                        }
                        description
                        descriptionHtml
                    }
            }
        }
    }
}
  `;

  const [variantList, setvariantList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [GetProducts, { loading, data, errors }] = useLazyQuery(GET_VARIANTS, {
    fetchPolicy: 'no-cache',
    context: { clientName: 'shopify-link' },
  });

  useEffect(() => {
    if (data && data.productVariants) {
      setvariantList(() => {
        const result = [];
        data.productVariants.edges.map((variant) =>
          result.push({
            value: `${variant.node.title} - ${variant.node.product.title}`,
            label: `${variant.node.title} - ${variant.node.product.title}`,
            id: variant.node.id,
            title: variant.node.product.title,
            images: variant.node.product.images.edges.map(img => {
              return img.node.originalSrc;
            }),
            price: variant.node.price,
            productId: variant.node.product.id.match(/\d+/)[0],
            variantId: variant.node.id.match(/\d+/)[0],
            variantName: variant.node.title,
            selectedOptions: variant.node.selectedOptions,
            description: variant.node.product.description,
            descriptionHtml: variant.node.product.descriptionHtml,
            inventoryQuantity: 1
          })
        );
        return result;
      });
    }
  }, [data]);

  const updateText = useCallback(
    (value) => {
      setFieldValue(fieldName, { title: value, variantId: '' });
      if (value) {
        GetProducts({ variables: { query: `title:*${value}*` } });
      }
    },
    [value]
  );

  const updateSelection = useCallback(
    (selected) => {
      if (selected?.length > 0) {
        const variant = variantList.find((item) => item.value === selected[0]);
        setFieldValue(fieldName, {
          title: variant.title,
          image: variant.images[0],
          price: variant.price,
          productId: variant.productId,
          variantId: variant.variantId,
          variantName: variant.variantName,
          selectedOptions: variant.selectedOptions,
          inventoryQuantity: 1,
          description: variant.description,
          descriptionHtml: variant.descriptionHtml,
        });

        setSelectedOptions(selected);



        let flag = true;

        for (let i = 0; allVariants?.length > i; i++) {
          if (allVariants[i]?.title == variant.value) {
            flag = false;
            break;
          } else {
            flag = true;
          }
        }

        if (flag) {
          allVariants ? allVariants.push({
            title: variant.title,
            image: variant.images[0],
            price: variant.price,
            productId: variant.productId,
            variantId: variant.variantId,
            variantName: variant.variantName,
            selectedOptions: variant.selectedOptions,
            inventoryQuantity: 1,
            description: variant.description,
            descriptionHtml: variant.descriptionHtml,
          }) : allVariants = [{
            title: variant.title,
            image: variant.images[0],
            price: variant.price,
            productId: variant.productId,
            variantId: variant.variantId,
            variantName: variant.variantName,
            selectedOptions: variant.selectedOptions,
            description: variant.description,
            descriptionHtml: variant.descriptionHtml,
            inventoryQuantity: 1
          }];
        }
        setAllVarients(allVariants)
      }
    },
    [variantList, value]
  );

  const textField = (
    <Autocomplete.TextField
      onChange={updateText}
      label=""
      type="text"
      value={value.title}
      prefix={<Icon source={SearchMinor} color="base" />}
      placeholder={i18n.t('search_variant_to_add')}
      error={error}
      suffix={
        loading && (
          <Spinner accessibilityLabel="Small spinner example" size="small" />
        )
      }
    />
  );

  const emptyState = (
    <React.Fragment>
      <Icon source={SearchMinor} />
      <div style={{ textAlign: 'center' }}>
        <TextContainer>Could not find any results</TextContainer>
      </div>
    </React.Fragment>
  );
  return (
    <Autocomplete
      options={variantList ?? variantList}
      selected={selectedOptions}
      onSelect={updateSelection}
      textField={textField}
      emptyState={emptyState}
      willLoadMoreResults={true}
    />
  );
};

export default SearchVariants;
